import type { SupportedLocales } from '~~/layers/i18n/nuxt.config'

export const useLanguageUtils = () => {
  const { locales } = useRuntimeConfig().public
  const { licensedTerritories } = locales
  const { defaultLocale, locale: selectedLocale, t } = useNuxtApp().$i18n

  const licensedTerritory = useLicensedTerritory({ raw: true })

  const options = computed(() =>
    (locales.supported as { code: string; language: string }[]).map(
      (locale) => ({
        customProps: {
          locale: locale.code,
        },
        label: getLocaleLabel(locale.code),
        selected: locale.code === selectedLocale.value,
        title: getLocaleLabel(locale.code),
        value: locale.code,
      }),
    ),
  )

  const getLocaleLabel = (locale: string) =>
    t(`locale.${locale.toLocaleLowerCase().replace('-', '')}`)

  const supportedLocales = computed(
    () => locales.supported as SupportedLocales[],
  )

  const currentLocale = computed(() => {
    const selectedLanguage = supportedLocales.value.find(
      (locale) => locale.code === selectedLocale.value,
    )

    if (!defaultLocale) return 'en-US'.toLowerCase()

    const lang =
      selectedLanguage &&
      selectedLanguage.language &&
      licensedTerritories[
        selectedLanguage.language as keyof typeof licensedTerritories
      ].includes(licensedTerritory)
        ? selectedLanguage.language
        : defaultLocale

    return lang.toLowerCase()
  })

  const oldLocale = useState<SupportedLocales['code'] | undefined>(
    () => undefined,
  )

  return {
    currentLocale,
    oldLocale,
    options,
  }
}
